// An assistant's answer as live shows it (#242): GitHub's markdown, by the same two libraries
// (`react-markdown`, `remark-gfm`; Daniil's approval, 2026-10-18). Their defaults stay: raw HTML
// in an answer is never rendered and an unsafe link (javascript:, data:) loses its target. A link
// opens in a new tab, so the editor stays open (spec docs/specs/editor/assistant.md decision 5).
import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

import classes from "./assistant.module.css";

const PLUGINS = [remarkGfm];

const COMPONENTS: Components = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

export function AssistText({ text }: { text: string }) {
  return (
    <div className={classes.markdown}>
      <ReactMarkdown remarkPlugins={PLUGINS} components={COMPONENTS}>
        {text}
      </ReactMarkdown>
    </div>
  );
}
